import { Component } from '@angular/core';

@Component({
  selector: 'ngx-souscriptions',
  template: `<router-outlet></router-outlet>`,
})
export class SouscriptionsComponent {
}
